var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('pt-page-title',{attrs:{"title":"提交解读工单"}}),_c('pt-sub-title',{attrs:{"title":"客户信息"}}),_c('pt-apply-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }